import React, { useState, useEffect } from 'react';
import './ConfirmationPage.scss';
import { useNavigate } from 'react-router-dom';
import { miniApp } from '@telegram-apps/sdk-react';
import { useCart } from '../../contexts/CartContext';
import Button from '../../components/ui/Button';

function ConfirmationPageOrder() {
  const navigate = useNavigate();
  const {
            setIsCartOpen,
            setIsEnable,
            cartItems
          } = useCart();
  useEffect(() => {
      miniApp.setBackgroundColor('#161618');
      miniApp.setHeaderColor('#161618');
      setIsEnable(false);
    return () => {
      miniApp.setBackgroundColor('#1D1D20');
      miniApp.setHeaderColor('#1D1D20');
      setIsEnable(true);
    };
  }, []);

  return (
    <div className="confirmation-page">
      <div className="icon-check">
        <svg width="32" height="32" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.7096 6.29536C21.0987 6.68724 21.0965 7.32041 20.7046 7.70957L9.62772 18.7096C9.23776 19.0968 8.60839 19.0968 8.21844 18.7096L3.29536 13.8207C2.90348 13.4315 2.90127 12.7984 3.29043 12.4065C3.67959 12.0146 4.31276 12.0124 4.70464 12.4015L8.92308 16.5907L19.2954 6.29043C19.6872 5.90127 20.3204 5.90348 20.7096 6.29536Z" fill="white"/>
</svg>
      </div>
      <h2 className="title">Заказ оформлен</h2>
      <div className="subtitle">
        В течение 1 часа с вами свяжется менеджер для уточнения деталей
      </div>
      <div className='two-btn-container'>
        <Button className="btn-secondary large" onClick={() => navigate('/orders')}>
          К заказам
        </Button>
        <Button className="btn-primary large" onClick={() => navigate('/')}>
          На главную
        </Button>
      </div>
      
    </div>
  );
}

export default ConfirmationPageOrder;
